import { i18n } from '@/lib/i18n'

/**
 * Nhãn nền tảng kênh theo mã `platform` — MỘT nguồn cho mọi màn (dấu kênh, hộp
 * thoại giao kênh, tiêu đề hội thoại). Khớp `Platform` / `PlatformLabel` trong
 * backend `shared/constants.ts` (vd 3 = Zalo Bot, 13 = Telegram cá nhân — tài
 * khoản cá nhân gắn bot qua Telegram Business).
 *
 * Trước đây ba màn có ba bảng chép tay, lệch nhau: thiếu Zalo Bot (hiện "Kênh #3"),
 * Telegram cá nhân hiện "Telegram"…
 */
// Nhãn có phần mô tả tiếng Việt dùng getter để đọc ngôn ngữ lúc dùng; tên thương hiệu giữ nguyên.
export const PLATFORM_LABELS: Record<number, string> = {
  1: 'Zalo OA',
  get 2() { return i18n.t('common:channels.zaloPersonal') },
  3: 'Zalo Bot',
  10: 'Facebook Messenger',
  11: 'Instagram',
  12: 'Telegram Bot',
  get 13() { return i18n.t('common:channels.telegramPersonal') },
  20: 'Web Chat',
  30: 'Pancake (Facebook)',
  31: 'Pancake (Instagram)',
  32: 'Pancake (TikTok)',
  39: 'Pancake',
  40: 'TikTok Shop',
  41: 'Shopee',
}

/** Nhãn của một mã nền tảng; mã lạ → `fallback` (mặc định "Kênh #<mã>"). */
export function platformLabelOf(platform: number | null | undefined, fallback?: string): string {
  if (platform == null) return fallback ?? i18n.t('common:channels.unknown')
  return PLATFORM_LABELS[platform] ?? fallback ?? i18n.t('common:channels.channelN', { id: platform })
}
